import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { unimpersonateUser } from 'api/user';
import pages from 'pages';
import { useUser } from 'hooks/useUser';
import OnboardingNavDrawer from 'shared/components/Navigation/OnboardingNav/OnboardingNavDrawer';
import { useBreakpoints } from 'hooks/useWindowSize';
import { HeaderItemsWrapper, HeaderStyled } from './Onboarding.styles';
import { AccountMenu } from '../../../../shared/components/AccountMenu/AccountMenu';
import { Modal } from '../../../../shared/components/Modal/Modal';
import { toast } from '../../../../shared/components/Toast/Toast';
import { LogoutText } from '../../../../shared/components/Header/Header.styles';

export function OnboardingHeader() {
  const [openLogoutModal, setOpenLogoutModal] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const screenSize = useBreakpoints();
  const { logout, userResult, setUserResult } = useUser();

  const toggleModal = () => setOpenLogoutModal(!openLogoutModal);

  const { mutate: unimpersonateUserMutation } = useMutation({
    mutationFn: unimpersonateUser,
    onSuccess: ({ data }) => {
      const newUser = data.user;
      const newImpersonator = data?.impersonator;
      const impersonatedUserId = userResult?.user?.id;

      setUserResult({
        user: newUser,
        impersonator: newImpersonator,
        selectedAgreement: newUser.agreements[0],
      });

      navigate(`/${pages.ADMIN}/users/${impersonatedUserId}`);
    },
    onError: () => {
      toast({
        type: 'error',
        title: t('toast.error'),
        message: t('toast.somethingWentWrong'),
        theme,
      });
    },
  });

  const handleLogout = () => {
    logout({});
  };

  const name = userResult?.user?.first_name || '';

  return (
    <HeaderStyled $hasBreadCrumbs={false} $hasTitle={false}>
      <HeaderItemsWrapper>
        {screenSize === 'sm' && <OnboardingNavDrawer />}
        <AccountMenu
          name={name}
          title={t('account.account')}
          onUnImpersonateUser={userResult?.impersonator ? unimpersonateUserMutation : undefined}
          onLogout={toggleModal}
        />
      </HeaderItemsWrapper>

      <Modal
        isOpen={openLogoutModal}
        contentLabel="Log Out Modal"
        title={t('logoutModal.logout')}
        styleVariant="tertiary"
        isFullWidth
        zIndex={openLogoutModal ? 1002 : undefined}
        onRequestClose={toggleModal}
        ctaButtons={{
          tertiary: { label: t('cta.cancel'), onClick: toggleModal },
          primary: { label: t('logoutModal.logout'), onClick: handleLogout },
        }}
      >
        <LogoutText as="p">{t('logoutModal.areYouSure')}</LogoutText>
      </Modal>
    </HeaderStyled>
  );
}

export default OnboardingHeader;
